import React, {
    useContext,
  useState,
  useRef,
  useEffect,
} from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';

import { getCustomer, refetchCustomer, NotificationContext, handleError } from "../router"

import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";
import * as UTILS from "../utils";

import LoadingIndicator from '../components/loading-indicator';

export default function Preferences() {

    const {notification, setNotification} = useContext(NotificationContext);

    const { data: customer, isPending } = getCustomer();

    const [customerTagIds, setCustomerTagIds] = useState(null);
    
    const addContactPreference = useMutation({
        mutationFn: (statementId) => QUERIES.addContactPreference([{id: statementId}]),
        onError: (error) => {
            handleError(error.message, setNotification);
        }
    })

    const removeContactPreference = useMutation({
        mutationFn: (statementId) => QUERIES.removeContactPreference(statementId),
        onError: (error) => {
            handleError(error.message, setNotification);
        }
    })
    
    const addCustomerTag = useMutation({
        mutationFn: (tagId) => QUERIES.addCustomerTag([{id: tagId}]),
        onError: (error) => {
            handleError(error.message, setNotification);
        }
    })

    const removeCustomerTag = useMutation({
        mutationFn: (tagId) => QUERIES.removeCustomerTag(tagId),
        onError: (error) => {
            handleError(error.message, setNotification);
        }
    })

    const handleCheckboxChange = (e) => {
        if (!e) return;

        const checked = e.target.checked;
        const name = e.target.name;
        const value = e.target.value;

        if (checked) {
            if (name == 'contact-preference') addContactPreference.mutateAsync(value);
            if (name == 'tag') addCustomerTag.mutateAsync(value);
        } else {
            if (name == 'contact-preference') removeContactPreference.mutateAsync(value)
            if (name == 'tag') removeCustomerTag.mutateAsync(value);
        }
    }

    useEffect(() => {
        if (!customer) return;

        // Create a map of id's to compare against for checking on load
        const ids = UTILS.getCustomerTagIds(customer.tags);
        setCustomerTagIds(ids);

    }, [customer])

    return (
      <div className='booking-pathway__preferences'>
        <h2 className='booking-pathway__header'>Your Preferences</h2>

        <form className='booking-pathway__preferences--form'>
            {(customer?.allStatements?.length) &&
                <fieldset className='booking-pathway__preferences--contact-preferences'>
                    <legend>How can we contact you?</legend>
                    {customer?.allStatements.map((pref) => (
                        <div key={pref.id} className="form-field form-field--checkbox">
                            <input type="checkbox" 
                                    name="contact-preference" 
                                    id={pref.id} 
                                    value={pref.id}
                                    className="form-check-input" 
                                    defaultChecked={pref.agreed}
                                    onChange={(e) => handleCheckboxChange(e)} />
                            <label htmlFor={pref.id}>{pref.text}</label>
                       </div>
                    ))}
                </fieldset>
            }

            { CONSTANTS.TAGS?.length && isPending ?
                <LoadingIndicator />
            :
            CONSTANTS.TAGS?.length && customerTagIds != null &&
                <fieldset className='booking-pathway__preferences--tags'>
                    <legend>What are your interests?</legend>
                    {CONSTANTS.TAGS.map((pref) => (
                        <div key={pref.id} className="form-field form-field--checkbox">
                            <input type="checkbox" 
                                    name="tag" 
                                    id={pref.id}
                                    value={pref.id}
                                    className="form-check-input" 
                                    defaultChecked={customerTagIds.includes(pref.id)}
                                    onChange={(e) => handleCheckboxChange(e)} />
                            <label htmlFor={pref.id}>{pref.name}</label>
                        </div>
                    ))}
                </fieldset>
            }
            
        </form>

      </div>
    );
  }